// extracted by mini-css-extract-plugin
export var content = "_n1-1";
export var fullScreen = "_n1-0";